/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Celebration = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M16.3301 16.7397C15.5001 15.9097 14.3201 15.5697 13.1701 15.8097C12.0201 16.0597 11.0901 16.8697 10.6901 17.9697L4.23012 35.3697C3.76012 36.6397 4.06012 38.0297 5.02012 38.9897C5.68011 39.6497 6.54011 39.9997 7.43011 39.9997C7.83011 39.9997 8.24012 39.9297 8.64012 39.7797L26.0401 33.3197C27.1401 32.9097 27.9501 31.9797 28.2001 30.8397C28.4501 29.6897 28.1001 28.5097 27.2701 27.6797L16.3301 16.7397ZM13.5401 19.0297C13.6001 18.8697 13.7201 18.8097 13.8101 18.7897C13.8401 18.7897 13.8701 18.7797 13.9001 18.7797C13.9801 18.7797 14.0701 18.8097 14.1601 18.8897L15.5501 20.2797L18.3601 32.8997L14.6801 34.2697L11.9401 23.5397C11.9401 23.5397 11.9101 23.4697 11.9001 23.4397L13.5401 19.0297ZM7.57012 36.9197C7.38012 36.9897 7.25011 36.9197 7.17011 36.8297C7.09012 36.7497 7.01011 36.6197 7.08011 36.4297L10.0501 28.4497L11.8101 35.3497L7.57012 36.9297V36.9197ZM25.2101 30.1797C25.1901 30.2697 25.1301 30.3997 24.9701 30.4497L21.2601 31.8297L19.5901 24.2997L25.1201 29.8297C25.2401 29.9497 25.2401 30.0897 25.2201 30.1797H25.2101Z"
      fill="#000"
    />
    <path
      d="M23.9002 20.1002C24.2002 20.4002 24.5902 20.5502 24.9802 20.5502C25.3702 20.5502 25.7602 20.4002 26.0602 20.1002L33.8102 12.3502C34.4102 11.7502 34.4102 10.7902 33.8102 10.1902C33.2102 9.59023 32.2502 9.59023 31.6502 10.1902L23.9002 17.9402C23.3002 18.5402 23.3002 19.5002 23.9002 20.1002Z"
      fill="#000"
    />
    <path
      d="M18.8704 14.89C19.0504 14.96 19.2204 14.99 19.4004 14.99C20.0204 14.99 20.6004 14.61 20.8304 14L23.7804 6.07003C24.0704 5.28003 23.6704 4.40003 22.8804 4.11003C22.0904 3.82003 21.2104 4.22003 20.9204 5.01003L17.9704 12.94C17.6804 13.73 18.0804 14.61 18.8704 14.9V14.89Z"
      fill="#000"
    />
    <path
      d="M39.9 21.1204C39.61 20.3304 38.73 19.9304 37.94 20.2204L30.01 23.1704C29.22 23.4604 28.82 24.3404 29.11 25.1304C29.34 25.7404 29.92 26.1204 30.54 26.1204C30.72 26.1204 30.9 26.0904 31.07 26.0204L39 23.0704C39.79 22.7804 40.19 21.9004 39.9 21.1104V21.1204Z"
      fill="#000"
    />
    <path
      d="M34.8696 30.6504C33.8896 30.6504 33.0996 31.4504 33.0996 32.4204C33.0996 33.3904 33.8896 34.1804 34.8696 34.1804C35.8496 34.1804 36.6296 33.3904 36.6296 32.4204C36.6296 31.4504 35.8396 30.6504 34.8696 30.6504Z"
      fill="#000"
    />
    <path
      d="M37.4702 16.8796C38.4402 16.8796 39.2302 16.0896 39.2302 15.1096C39.2302 14.1296 38.4402 13.3496 37.4702 13.3496C36.5002 13.3496 35.7002 14.1396 35.7002 15.1096C35.7002 16.0796 36.4902 16.8796 37.4702 16.8796Z"
      fill="#000"
    />
    <path
      d="M28.8899 8.30953C29.8699 8.30953 30.6599 7.50953 30.6599 6.53953C30.6599 5.56953 29.8699 4.76953 28.8899 4.76953C27.9099 4.76953 27.1299 5.56953 27.1299 6.53953C27.1299 7.50953 27.9199 8.30953 28.8899 8.30953Z"
      fill="#000"
    />
    <path
      d="M11.9299 11.2605C12.9099 11.2605 13.6999 10.4605 13.6999 9.49047C13.6999 8.52047 12.9099 7.73047 11.9299 7.73047C10.9499 7.73047 10.1699 8.52047 10.1699 9.49047C10.1699 10.4605 10.9599 11.2605 11.9299 11.2605Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default Celebration
